import { toReaderLocale } from '@/utils/numberFormat';

const PERIOD_BOUND_TIME_ZONE = 'UTC';

interface ShortDateOptions {
    date: Date;
    language: string;
    timeZone?: string;
}

export const formatShortDate = ({ date, language, timeZone }: ShortDateOptions): string =>
    date.toLocaleDateString(toReaderLocale(language), {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone,
    });

interface PeriodRangeOptions {
    from: string;
    to: string;
    language: string;
}

export const formatPeriodRange = ({ from, to, language }: PeriodRangeOptions): string => {
    const fromLabel = formatShortDate({
        date: new Date(from),
        language,
        timeZone: PERIOD_BOUND_TIME_ZONE,
    });
    const toLabel = formatShortDate({
        date: new Date(to),
        language,
        timeZone: PERIOD_BOUND_TIME_ZONE,
    });

    return `${fromLabel} - ${toLabel}`;
};
